import { render, staticRenderFns } from "./AccessKeyList.vue?vue&type=template&id=2dc835ac"
import script from "./AccessKeyList.vue?vue&type=script&lang=ts"
export * from "./AccessKeyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports